export const openInNewTab = (url: string, newTab = true) => {
  if (!url) return;

  if (newTab) {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
    return;
  }

  window.location.href = url;
};

export const downloadFile = (url: string | Blob, fileName: string) => {
  let linkUrl = '';

  if (url instanceof Blob) {
    linkUrl = URL.createObjectURL(url);
  } else {
    linkUrl = url;
  }

  const a = document.createElement('a');
  a.href = linkUrl;
  a.target = '_blank';
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  if (url instanceof Blob) {
    URL.revokeObjectURL(linkUrl);
  }
};
